<template>
  <div>
    <div class="row form-group">
      <div class="col-md-12 text-center">
        <label for="logo-image">
          <img id="logo" class="ts-h-40 ts-w-32" :src="logo_file_src" alt />
        </label>
        <div class="validate" v-if="errors.has('logo_file')">
          {{ errors.first('logo_file') }}
        </div>
        <input
          type="file"
          id="logo-image"
          ref="logoimage"
          style="display:none"
          @change="onFileChange"
        />
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('company.companyNameKH') }}</label>
        <input
          type="text"
          class="form-control"
          v-model.trim="model.company_name_kh"
        />
        <div class="validate" v-if="errors.has('company_name_kh')">
          {{ errors.first('company_name_kh') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{
          $t('company.companyNameEN')
        }}</label>
        <input
          type="text"
          class="form-control"
          v-model.trim="model.company_name_en"
        />
        <div class="validate" v-if="errors.has('company_name_en')">
          {{ errors.first('company_name_en') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('company.phone') }}</label>
        <input
          type="text"
          class="form-control"
          v-model.trim="model.company_phone"
        />
        <div class="validate" v-if="errors.has('company_phone')">
          {{ errors.first('company_phone') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('company.email') }}</label>
        <input
          type="email"
          class="form-control"
          v-model.trim="model.company_email"
        />
        <div class="validate" v-if="errors.has('company_email')">
          {{ errors.first('company_email') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('company.website') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="model.company_website"
        />
        <div class="validate" v-if="errors.has('company_website')">
          {{ errors.first('company_website') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('company.address') }}</label>
        <textarea
          rows="3"
          class="form-control"
          v-model.trim="model.company_address"
        ></textarea>
        <div class="validate" v-if="errors.has('company_address')">
          {{ errors.first('company_address') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">{{
          $t('cancel')
        }}</ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      logo_file: null,
      logo_file_src: require('../../../assets/camera.png'),
      waiting: false,
      model: {
        company_id: null,
        company_name_kh: null,
        company_name_en: null,
        company_address: null,
        company_phone: null,
        company_email: null,
        company_website: null,
        company_logo: null
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('administrator/company', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onFileChange() {
      const file = this.$refs.logoimage.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
          this.logo_file = file
        } else {
          this.logo_file_src = require('../../../assets/camera.png')
          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },
    async uploadLogo() {
      if ((this.logo_file instanceof File) | Blob) {
        let formData = new FormData()
        formData.append('logo_file', this.logo_file)
        let response = await this.$store.dispatch(
          'administrator/company/upload',
          formData
        )
        this.model.company_logo = response
      }
      return ''
    },
    async onSave() {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('administrator/company/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onUpdate() {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('administrator/company/update', {
          id: this.model.company_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.company_id = this.edit_data.company_id
        this.model.company_name_kh = this.edit_data.company_name_kh
        this.model.company_name_en = this.edit_data.company_name_en
        this.model.company_address = this.edit_data.company_address
        this.model.company_phone = this.edit_data.company_phone
        this.model.company_email = this.edit_data.company_email
        this.model.company_website = this.edit_data.company_website
        this.model.company_logo = this.edit_data.company_logo
        if (this.edit_data.company_logo) {
          this.logo_file_src = this.edit_data.company_logo
        }
      }
    }
  }
}
</script>

<style scoped>
#logo {
  border: 1px solid rgb(230, 230, 230);
  width: 250px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0px 0px 11px 0px #dcdbdb;
}
#logo:hover {
  box-shadow: 0px 0px 11px 5px #dcdbdb;
}
</style>
